import React from "react";
import {Slider} from "antd";
import "./filter-components.scss";
import {AREA_TYPES, ROOM_COUNTS} from "../../constants/constants";
import {priceWithCommas} from "../../utils/helperFunctions";
import {Dram_icon, InstagramIcon} from "../../assets/images";

export function RoomCounter(props) {
    const {staticTexts, changeFilter, activeRooms, disabled} = props;
    return <div className={'rooms-counts'}>
        <div className={'block-title'}>{staticTexts?.filter_rooms_count_title}</div>
        <div className={'rooms-count-content'}>
            {ROOM_COUNTS.map((roomNumber) => {
                return <button key={roomNumber}
                               className={`rooms-count-item
                                ${activeRooms && activeRooms?.includes(roomNumber) ? 'active' : ''}
                                ${disabled ? 'rooms-disabled-count-item' : ''}`}
                               onClick={() => {
                                   !disabled && changeFilter('roomsCount', roomNumber)
                               }}
                >{roomNumber}</button>
            })}
        </div>
    </div>

}

export function CustomRangeSlider(props) {
    const {title,filter_from, filter_to, MIN_VALUE, MAX_VALUE, minValue, maxValue, onChangeSlider, onAfterChange,staticTexts} = props;
    return <div className={'price-slider'}>
        <div className={'block-title'}>{title}</div>
        <div className={'border-block'}>
            <div className={'slider-filter-top'}>
                <div className={'left-block'}>
                    <span>{filter_from}</span>
                    <div className={'filters-area'}>{priceWithCommas(minValue)}{staticTexts ?
                        <div className={'measurement'}>{staticTexts?.measurement_unit_meter} <sup>2</sup></div> : <Dram_icon/>} </div>
                </div>
                <div className={'right-block'}>
                    <span>{filter_to}</span>
                    <div className={'filters-area'}>{priceWithCommas(maxValue)}{staticTexts ? <div className={'measurement'}>{staticTexts?.measurement_unit_meter} <sup>2</sup></div> : <Dram_icon/>}</div>
                </div>
                <div className={'border'}/>
            </div>
            <Slider range
                    min={MIN_VALUE}
                    max={MAX_VALUE}
                    value={[
                        typeof minValue === 'number' ? minValue : MIN_VALUE,
                        typeof maxValue === 'number' ? maxValue : MAX_VALUE
                    ]}
                    tipFormatter={null}
                    onChange={onChangeSlider}
                    onChangeComplete={onAfterChange}
            />
        </div>
    </div>


}
